export const formattedContent = (content: any, isMobileFlow: boolean, updatedContent: any) => {
  const obj: any = {
    displayName: '',
    description: '',
    icon: '',
    code: '',
    productDetailsModal: [],
    pageType: '',
    highlightText: '',
    promoID: '',
    productConfig: [],
    entitlementConfig: [],
    benefitsSection: [],
    serviceOptions: {
      avalaible: false,
      promotion: '',
      ids: new Set(),
      product: '',
      radioValue: '',
      tvChannelName: '',
      poType: ''
    },
    countryListUrl: '',
    promoObj: [],
    addSmartPhone: [],
    promoText: '',
    priceDisplayText: '',
    cardImg:'',
    bestSellerColor:'',
  };
  const productSbObj = isMobileFlow ? content?.productStroyObj.stroy : content?.productStroyObj;
  obj.displayName = productSbObj?.content?.body?.[0]?.displayName;
  obj.code = productSbObj?.content?.body?.[0]?.code;
  obj.highlightText = content?.highlightText;
  obj.promoText = productSbObj?.content?.body?.[0]?.promoText;
  obj.cardImg=productSbObj?.content?.body?.[0]?.img?.filename;
  if (content?.promStroyObj) {
    const tempPromotion: any = {};
    obj.promoID = content?.promStroyObj?.prom;
    obj.serviceOptions.promotion = content?.promStroyObj?.prom;
    const stroyObj: any = content?.promStroyObj?.stroy;
    const blok = stroyObj?.content;
    if (blok && blok?.promoDescription && blok?.promoDescription.length > 0) {
      for (let k = 0; k < blok.promoDescription.length; k++) {
        const value = blok.promoDescription[k];
        if (content.promStroyObj.prom === value.parent_promo_id) {
          tempPromotion.promotion = value?.parent_promo_id; // added for passing promotion id to configurator page.
          tempPromotion.description = value?.description;
          tempPromotion.isPricingPromo = false;
          tempPromotion.isGiftPromo = false;
          tempPromotion.isDefault = content?.promStroyObj?.isDefault;
          tempPromotion.displayText = value?.displayText;
          tempPromotion.bestSellerColor=value?.bestSellerColor;
          tempPromotion.cashback = value?.cashback;
          if (value.type.includes('pricing')) {
            tempPromotion.isPricingPromo = true;
          } else if (value.type.includes('gift')) {
            tempPromotion.isGiftPromo = true;
            tempPromotion.giftConfig = value?.giftConfig;
            tempPromotion.giftConfigV2 = value?.giftConfigV2;
            tempPromotion.parentPoType = isMobileFlow ? 'MOBILE' : 'HOME';
          }
          if (
            (tempPromotion?.isPricingPromo || tempPromotion?.isGiftPromo) &&
            !content?.products?.dontShowPromotion
          ) {
            obj.priceDisplayText = value?.displayText;
            obj.bestSellerColor=value?.bestSellerColor;
          }
          break;
        }
      }
    }
    obj.promoObj.push(tempPromotion);
  }

  if (!isMobileFlow) {
    const tvOptions = ['NETFLIX', 'SPORTS'];
    obj.description = productSbObj?.content?.body?.[0]?.description;
    obj.productDetailsModal = productSbObj?.content?.body?.[0]?.productDetailsModal;
    obj.pageType = 'HOME';
    if (productSbObj?.content?.body?.[0]?.products?.length > 0) {
      const productList = sortProductDetails(productSbObj?.content?.body?.[0]?.products);
      if (productList?.length > 0) {
        const productConfigDetais: any = [];
        const prodEntitlement: any = [];
        productList?.map((details: any) => {
          const bundleConfigValue = details?.bundleConfig?.[0];
          const prodDetails: any = {
            icon: bundleConfigValue?.bundleIcon?.filename,
            name: bundleConfigValue?.bundleDisplayName
              ? bundleConfigValue?.bundleDisplayName
              : details.displayName,
            description: bundleConfigValue?.description
              ? bundleConfigValue?.description
              : details.description,
            tooltip: details?.toolTipText,
            linkText: details.linkText,
            includeDescription: bundleConfigValue?.includeDescription,
            includeEntitlement: bundleConfigValue?.includeEntitlement,
            poType: details?.poType
          };

          if (bundleConfigValue?.includeEntitlement && details?.entitlementConfig?.length > 0) {
            details?.entitlementConfig?.map((entitlement: any) => {
              entitlement?.entitlementValues?.map((entitleValues: any) => {
                const entitlementDetails: any = {
                  icon: entitleValues?.icon?.filename,
                  toolTip: entitleValues?.toolTipText,
                  entitlement: entitleValues?.value,
                  disabled: entitleValues?.disabled
                };
                prodEntitlement?.push(entitlementDetails);
              });
            });
          }
          productConfigDetais?.push(prodDetails);
          if (details?.poType === 'TV') {
            if (tvOptions.includes(details?.tvGroup)) {
              obj.serviceOptions.poType = 'TV';
              obj.serviceOptions.radioValue = details?.code;
              if (details?.tvGroup == 'NETFLIX') {
                obj.serviceOptions.tvChannelName = 'Netflix';
              } else if (details?.tvGroup == 'SPORTS') {
                obj.serviceOptions.tvChannelName = details?.displayName + ' ' + details?.tvLang;
              } else {
                obj.serviceOptions.tvChannelName = 'TV Box';
              }
              obj.serviceOptions.avalaible = true;
              obj.serviceOptions.product = details?.code;
              obj.serviceOptions.ids.add(details?.tvGroupProdPath);
            }
          }
        });
        obj.productConfig = productConfigDetais;
        obj.entitlementConfig = prodEntitlement;
      }
    }
    if (productSbObj?.content?.body?.[0]?.benefitsSection?.length > 0) {
      const benefitsSectionDEtails: any = [];
      productSbObj?.content?.body?.[0]?.benefitsSection?.map((benefits: any) => {
        const benefitsObj = {
          icon: benefits?.icon?.filename,
          id: benefits?.id,
          text: benefits?.text,
          toolTip: benefits?.tooltip
        };
        benefitsSectionDEtails?.push(benefitsObj);
      });
      obj.benefitsSection = benefitsSectionDEtails;
    }
    if (productSbObj?.content?.body?.[0]?.addnEntitlements?.length > 0) {
      productSbObj?.content?.body?.[0]?.addnEntitlements?.map((addnEntitleValue: any) => {
        const prodDetails: any = {
          icon: addnEntitleValue?.icon?.filename,
          name: addnEntitleValue?.text,
          description: addnEntitleValue?.description,
          tooltip: addnEntitleValue?.toolTip,
          linkText: addnEntitleValue?.linkText,
          includeDescription: addnEntitleValue?.includeDescription ?? false,
          includeEntitlement: addnEntitleValue?.includeEntitlement ?? false
        };
        if (obj.productConfig?.length > 0) {
          obj.productConfig.push(prodDetails);
        } else {
          obj.productConfig = prodDetails;
        }
      });
    }
  } else {
    obj.description = productSbObj?.content?.body?.[0]?.introText;
    obj.productDetailsModal = productSbObj?.content?.body?.[0]?.subscriptionDetailModal;
    obj.icon = productSbObj?.content?.body?.[0]?.prodImage?.filename;
    obj.pageType = 'MOBILE';
    obj.countryListUrl = {
      reference: productSbObj?.content?.body?.[0]?.countryList?.cached_url
    };

    if (productSbObj?.content.body?.[0]?.entitlementConfig?.length > 0) {
      const productConfigDetais: any = [];
      productSbObj?.content.body?.[0]?.entitlementConfig?.map((details: any) => {
        const prodDetails: any = {
          icon: details?.entitlementIcon?.filename,
          name: details?.entitlementName,
          description: details?.entitlementDescription,
          tooltip: details?.tooltip,
          linkText: details?.linkText,
          includeDescription: details?.includeDescription
        };
        productConfigDetais.push(prodDetails);
      });
      obj.productConfig = productConfigDetais;
    }
    if (productSbObj?.content?.body?.[0]?.extraOptions?.length > 0) {
      const benefitsSectionDEtails: any = [];
      productSbObj?.content?.body?.[0]?.extraOptions?.map((benefits: any) => {
        const benefitsObj = {
          icon: benefits?.entitlementIcon?.filename,
          id: 'default',
          text: benefits?.entitlementName,
          toolTip: benefits?.tooltip,
          isMMC:benefits?.isMMC,
          isMobileFMC:benefits?.isFMC
        };
        benefitsSectionDEtails?.push(benefitsObj);
      });
      obj.benefitsSection = benefitsSectionDEtails;
    }
    if (updatedContent?.addSmartphone?.length > 0) {
      obj.addSmartPhone = updatedContent?.addSmartphone;
    }
  }
  return obj;
};

export const sortProductDetails = (prodDetails: any) => {
  //for each product get the product info from StoryBlok
  const childProducts: any = [];
  prodDetails?.map((product: any) => {
    const sort: number = Number(product?.order) || 999;
    const tempProductData: any = product?.cProd;
    tempProductData.sortOrder = sort;
    childProducts?.push(tempProductData);
  });
  childProducts?.sort((a: any, b: any) => a?.sortOrder - b?.sortOrder);
  return childProducts;
};

export const checkGift = (data: any): any => {
  let isGift = false;
  data?.map((product: any) => {
    product?.promotionInfo?.map((offer: any) => {
      if (offer?.hardwareGift) isGift = true;
    });
  });
  return isGift;
};

export const checkCashback = (data: any): any => {
  let isCashback = false;
  data?.map((product: any) => {
    product?.promotionInfo?.map((offer: any) => {
      if (offer?.cashBack) isCashback = true;
    });
  });
  return isCashback;
};

/**
 * retrieves access data from the line check data based on provided product id
 * @param productId the id to search for in the line check response
 * @returns accessData for the particular product
 */
export const getAccessDataFromLineCheck = (productId: any): any => {
  let accessData: any = [];
  let lineCheckResponse: any =
    typeof window !== undefined && localStorage.getItem('lineCheckResponse');
  if (lineCheckResponse) {
    lineCheckResponse = JSON.parse(lineCheckResponse);
    const sellableProducts = lineCheckResponse?.originalLinecheckResponse?.sellableProducts;
    accessData = sellableProducts?.find((item: any) => item?.name === productId)?.access?.[0];
  }
  return accessData;
};
